export const types = {
    SET_POPOVER_CONTENT: 'sidebar/SET_POPOVER_CONTENT',
    CLOSE_POPOVER: 'sidebar/CLOSE_POPOVER',
    SHOW_POPOVER_CONTENT: 'sidebar/SHOW_POPOVER_CONTENT',
    SET_NAMED_LIST: 'sidebar/SET_NAMED_LIST',
    TOGGLE_SIDEBAR_COLLAPSE: 'sidebar/TOGGLE_SIDEBAR_COLLAPSE',
};
